export default __webpack_public_path__ + "static/media/kast-apelsin.9ca5296c.jpeg";